import React from 'react';
import ko from 'knockout';
import 'devexpress-reporting/dx-webdocumentviewer';

// nodejs library to set properties for components
import PropTypes from "prop-types";

export class OthelloReportViewer extends React.Component {
    constructor(props) {
        super(props);

        this.uri = window.location.origin+"|";
        this.listado = props.listado != null && props.listado != "" ? props.listado : "DefaultReport";
        this.dataurl = props.data != null && props.data != "" ? "|" + props.data : "";

        this.reportUrl = ko.observable(this.uri+ this.listado + (this.dataurl != "" ? this.dataurl : ""));

        this.requestOptions = {
            //host: "http://localhost:53550/",
            invokeAction: "DXXRDV" 
        };      
    }
    render() {
        return (<div ref="viewer" data-bind="dxReportViewer: $data"></div>);
    }
    componentDidMount() {
        ko.applyBindings({
            reportUrl: this.reportUrl ,
            //viewerModel: this.previewModel,
            requestOptions: this.requestOptions
        }, this.refs.viewer);
    }
    componentWillUnmount() {
        ko.cleanNode(this.refs.viewer);
    }
};


OthelloReportViewer.propTypes = {
    //Nombre del listado a mostrar
    listado: PropTypes.string,
    data: PropTypes.object
}